<div class="content dark">
	<ul ngbNav #nav="ngbNav" class="nav-tabs light">
		<li ngbNavItem>
			<a ngbNavLink>Control Bucket</a>
			<ng-template ngbNavContent>
				<app-files-control [asset]="asset"></app-files-control>
			</ng-template>
		</li>
		<li ngbNavItem>
			<a ngbNavLink>Failed Imports</a>
			<ng-template ngbNavContent>
				<app-files-error [asset]="asset"></app-files-error>
			</ng-template>
		</li>
		<li ngbNavItem>
			<a ngbNavLink>ACEX</a>
			<ng-template ngbNavContent>
				<app-files-datafile [asset]="asset" filetype="ACEX"></app-files-datafile>
			</ng-template>
		</li>
		<li ngbNavItem>
			<a ngbNavLink>ACOP</a>
			<ng-template ngbNavContent>
				<app-files-datafile [asset]="asset" filetype="ACOP"></app-files-datafile>
			</ng-template>
		</li>
		<li ngbNavItem>
			<a ngbNavLink>ACSTATE</a>
			<ng-template ngbNavContent>
				<app-files-datafile [asset]="asset" filetype="ACSTATE"></app-files-datafile>
			</ng-template>
		</li>
		<li ngbNavItem>
			<a ngbNavLink>CI</a>
			<ng-template ngbNavContent>
				<app-files-datafile [asset]="asset" filetype="CI"></app-files-datafile>
			</ng-template>
		</li>
		<li ngbNavItem>
			<a ngbNavLink>CYCNT</a>
			<ng-template ngbNavContent>
				<app-files-datafile [asset]="asset" filetype="CYCNT"></app-files-datafile>
			</ng-template>
		</li>
		<li ngbNavItem>
			<a ngbNavLink>EVNT</a>
			<ng-template ngbNavContent>
				<app-files-datafile [asset]="asset" filetype="EVNT"></app-files-datafile>
			</ng-template>
		</li>
		<li ngbNavItem>
			<a ngbNavLink>LOG</a>
			<ng-template ngbNavContent>
				<app-files-datafile [asset]="asset" filetype="LOG"></app-files-datafile>
			</ng-template>
		</li>
		<li ngbNavItem>
			<a ngbNavLink>OBCUSTAT</a>
			<ng-template ngbNavContent>
				<app-files-datafile [asset]="asset" filetype="OBCUSTAT"></app-files-datafile>
			</ng-template>
		</li>
		<li ngbNavItem>
			<a ngbNavLink>PARAM</a>
			<ng-template ngbNavContent>
				<app-files-datafile [asset]="asset" filetype="PARAM"></app-files-datafile>
			</ng-template>
		</li>
		<li ngbNavItem>
			<a ngbNavLink>PCS</a>
			<ng-template ngbNavContent>
				<app-files-datafile [asset]="asset" filetype="PCS"></app-files-datafile>
			</ng-template>
		</li>
		<li ngbNavItem>
			<a ngbNavLink>RAW</a>
			<ng-template ngbNavContent>
				<app-files-datafile [asset]="asset" filetype="RAW"></app-files-datafile>
			</ng-template>
		</li>
		<li ngbNavItem>
			<a ngbNavLink>TACH</a>
			<ng-template ngbNavContent>
				<app-files-datafile [asset]="asset" filetype="TACH"></app-files-datafile>
			</ng-template>
		</li>
	</ul>
	<div [ngbNavOutlet]="nav"></div>
</div>